import { Injectable } from "@angular/core"; 
import { DataService } from "./data.service";

@Injectable({
    providedIn: 'root'
  })
  export class PacsLinkedImageService {

    constructor( private dataService: DataService) { }
       
    async getLinkedImagesBase64( studyReportId: number ): Promise<string[]> {
        const params = {  studyReportId };
        return await this.dataService
            .get<string[]>('/pacsLinkedImage/getLinkedImagesBase64/', params).toPromise();
        }
  }